import { z } from 'zod';

export const ResourceSchema = z.object({
  resource_type: z.literal('source'),
  resource_id: z.string(),
  metadata: z.record(z.string()),
});

export type Resource = z.infer<typeof ResourceSchema>;
